import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import React from 'react';
import { Form, InputNumber, Select } from 'antd';
import styled, { createGlobalStyle } from 'styled-components';
import { styleVariables } from '@lib/common';
import { Expectation, ExpectationUnit } from '@module/assignment';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var formatTemplate = function formatTemplate(template, params) {
  if (!template) return '';
  return Object.entries(params).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        val = _ref2[1];

    return acc.replaceAll("{".concat(key, "}"), String(val)).replaceAll("{{".concat(key, "}}"), String(val));
  }, template);
};

var getHintText = function getHintText(isPercentage, value, maxScore, label) {
  if (isPercentage) {
    if (value != null && !isNaN(value) && value >= 0 && value <= 100) {
      var score = Math.round(value * maxScore / 100 * 10) / 10;
      return formatTemplate(label === null || label === void 0 ? void 0 : label.expectationPercentageHintWithValue, {
        percent: value,
        score: score,
        total: maxScore
      });
    }

    var _defaultScore = Math.round(50 * maxScore / 100 * 10) / 10;

    return formatTemplate(label === null || label === void 0 ? void 0 : label.expectationPercentageHintDefault, {
      score: _defaultScore,
      total: maxScore,
      percent: 50
    });
  }

  if (value != null && !isNaN(value) && value >= 0 && value <= maxScore) {
    var percent = maxScore > 0 ? Math.round(value / maxScore * 100) : 0;
    return formatTemplate(label === null || label === void 0 ? void 0 : label.expectationScoreHintWithValue, {
      score: value,
      total: maxScore,
      percent: percent
    });
  }

  var defaultScore = Math.round(maxScore / 2 * 10) / 10;
  return formatTemplate(label === null || label === void 0 ? void 0 : label.expectationScoreHintDefault, {
    score: defaultScore,
    total: maxScore
  });
};

var DropdownStyle = createGlobalStyle([".expectation-dropdown-overlay{border-radius:10px !important;padding:4px !important;box-shadow:0 4px 16px rgba(0,0,0,0.12) !important;border:1px solid #e5e7eb !important;background-color:#ffffff !important;.ant-select-item{border-radius:6px !important;padding:8px 12px !important;min-height:36px !important;display:flex !important;align-items:center !important;}.ant-select-item-option-selected:not(.ant-select-item-option-disabled){background-color:#e6f7ff !important;color:#1890ff !important;font-weight:500 !important;}.ant-select-item-option-active:not(.ant-select-item-option-selected):not(.ant-select-item-option-disabled){background-color:#f3f4f6 !important;}}"]);
var StyledContainer = styled.div.withConfig({
  displayName: "expectation-input-itemcomponent__StyledContainer",
  componentId: "sc-1l4jlfa-0"
})(["display:flex;flex-direction:column;width:100%;margin-bottom:16px;"]);
var StyledHeaderRow = styled.div.withConfig({
  displayName: "expectation-input-itemcomponent__StyledHeaderRow",
  componentId: "sc-1l4jlfa-1"
})(["display:flex;justify-content:space-between;align-items:center;width:100%;margin-bottom:8px;"]);
var StyledTitleLabel = styled.span.withConfig({
  displayName: "expectation-input-itemcomponent__StyledTitleLabel",
  componentId: "sc-1l4jlfa-2"
})(["font-size:14px;font-weight:600;color:#1f2937;"]);
var StyledRequired = styled.span.withConfig({
  displayName: "expectation-input-itemcomponent__StyledRequired",
  componentId: "sc-1l4jlfa-3"
})(["color:", ";margin-left:4px;"], styleVariables.colors.red4);
var StyledTotalScoreBadge = styled.span.withConfig({
  displayName: "expectation-input-itemcomponent__StyledTotalScoreBadge",
  componentId: "sc-1l4jlfa-4"
})(["background-color:#f1f5f9;color:#334155;font-size:13px;font-weight:500;padding:3px 12px;border-radius:9999px;border:1px solid #cbd5e1;line-height:20px;white-space:nowrap;"]);
var StyledSubLabelsRow = styled.div.withConfig({
  displayName: "expectation-input-itemcomponent__StyledSubLabelsRow",
  componentId: "sc-1l4jlfa-5"
})(["display:flex;gap:8px;width:100%;margin-bottom:6px;font-size:13px;font-weight:600;color:#64748b;"]);
var StyledSubLabelUnit = styled.span.withConfig({
  displayName: "expectation-input-itemcomponent__StyledSubLabelUnit",
  componentId: "sc-1l4jlfa-6"
})(["flex:0 0 30%;min-width:130px;"]);
var StyledSubLabelValue = styled.span.withConfig({
  displayName: "expectation-input-itemcomponent__StyledSubLabelValue",
  componentId: "sc-1l4jlfa-7"
})(["flex:1;"]);
var StyledInputsRow = styled.div.withConfig({
  displayName: "expectation-input-itemcomponent__StyledInputsRow",
  componentId: "sc-1l4jlfa-8"
})(["display:flex;gap:8px;align-items:flex-start;width:100%;"]);
var StyledTypeSelect = styled(Select).withConfig({
  displayName: "expectation-input-itemcomponent__StyledTypeSelect",
  componentId: "sc-1l4jlfa-9"
})(["flex:0 0 30%;min-width:130px;.ant-select-selector{border-radius:8px !important;height:40px !important;display:flex !important;align-items:center !important;border:1px solid #d9d9d9 !important;background-color:#ffffff !important;padding:0 12px !important;}.ant-select-selection-item{font-size:14px;color:#1f2937;}&:hover .ant-select-selector{border-color:#40a9ff !important;}&.ant-select-focused .ant-select-selector{border-color:#1890ff !important;box-shadow:0 0 0 2px rgba(24,144,255,0.2) !important;}"]);
var StyledValueFormItem = styled(Form.Item).withConfig({
  displayName: "expectation-input-itemcomponent__StyledValueFormItem",
  componentId: "sc-1l4jlfa-10"
})(["flex:1;margin-bottom:0 !important;.ant-form-item-explain{font-size:13px;margin-top:6px;line-height:1.4;}.ant-form-item-extra{font-size:13px;color:#64748b;margin-top:6px;line-height:1.4;}&.ant-form-item-has-error .ant-form-item-extra{display:none !important;}"]);
var StyledInputWrapper = styled.div.withConfig({
  displayName: "expectation-input-itemcomponent__StyledInputWrapper",
  componentId: "sc-1l4jlfa-11"
})(["display:flex;align-items:center;height:40px;border-radius:8px !important;border:1px solid #d9d9d9;background-color:#ffffff;padding:0 12px;transition:all 0.2s ease;.ant-form-item-has-error &{border-color:#ff4d4f !important;}&:hover{border-color:#40a9ff;.ant-form-item-has-error &{border-color:#ff4d4f !important;}}&:focus-within{border-color:#1890ff;box-shadow:0 0 0 2px rgba(24,144,255,0.2);.ant-form-item-has-error &{border-color:#ff4d4f !important;box-shadow:0 0 0 2px rgba(255,77,79,0.2) !important;}}.ant-input-number{flex:1;border:none !important;box-shadow:none !important;background:transparent !important;height:38px;padding:0;.ant-input-number-input{height:38px;padding:0;font-size:14px;color:#1f2937;}.ant-input-number-handler-wrap{display:none;}}"]);
var StyledSuffixText = styled.span.withConfig({
  displayName: "expectation-input-itemcomponent__StyledSuffixText",
  componentId: "sc-1l4jlfa-12"
})(["color:#64748b;font-size:14px;font-weight:500;user-select:none;margin-left:8px;white-space:nowrap;"]);
export var ExpectationInputItem = function ExpectationInputItem(_ref3) {
  var label = _ref3.label,
      errorLabel = _ref3.errorLabel,
      _ref3$isRequired = _ref3.isRequired,
      isRequired = _ref3$isRequired === void 0 ? true : _ref3$isRequired,
      formTotalScore = _ref3.formTotalScore,
      onValuesChange = _ref3.onValuesChange;
  var maxScore = formTotalScore && formTotalScore > 0 ? formTotalScore : 10;
  var percentageLabel = label === null || label === void 0 ? void 0 : label.expectationTypePercentage;
  var scoreLabel = label === null || label === void 0 ? void 0 : label.expectationTypeScore;
  var unitLabel = label === null || label === void 0 ? void 0 : label.unit;
  var valueLabel = label === null || label === void 0 ? void 0 : label.value;
  var totalFormScoreText = formatTemplate(label === null || label === void 0 ? void 0 : label.totalFormScore, {
    score: maxScore
  });
  var percentageErrorMsg = errorLabel === null || errorLabel === void 0 ? void 0 : errorLabel.expectationPercentageOutOfRange;
  var scoreErrorMsg = formatTemplate(errorLabel === null || errorLabel === void 0 ? void 0 : errorLabel.expectationScoreOutOfRange, {
    max: maxScore
  });
  return /*#__PURE__*/_jsx(Form.Item, {
    noStyle: true,
    shouldUpdate: function shouldUpdate(prevValues, currentValues) {
      return prevValues.expectationType !== currentValues.expectationType || prevValues.expectation !== currentValues.expectation;
    },
    children: function children(_ref4) {
      var getFieldValue = _ref4.getFieldValue,
          setFieldsValue = _ref4.setFieldsValue;
      var expectationType = getFieldValue('expectationType') || ExpectationUnit.Percentage;
      var isPercentage = expectationType === ExpectationUnit.Percentage;
      var currentExpectationValue = getFieldValue('expectation');
      var numVal = currentExpectationValue != null && currentExpectationValue !== '' ? Number(currentExpectationValue) : null;
      var hintText = getHintText(isPercentage, numVal, maxScore, label);

      var handleTypeChange = function handleTypeChange(newType) {
        setFieldsValue({
          expectationType: newType,
          expectation: newType === ExpectationUnit.Percentage ? 50 : Math.round(maxScore / 2)
        });
        onValuesChange === null || onValuesChange === void 0 ? void 0 : onValuesChange();
      };

      var handleInputChange = function handleInputChange(val) {
        if (val === null || val === undefined || val === '') {
          setFieldsValue({
            expectation: null
          });
          return;
        }

        var num = typeof val === 'string' ? parseFloat(val) : val;
        setFieldsValue({
          expectation: isNaN(num) ? null : Number(num.toFixed(3))
        });
      };

      return /*#__PURE__*/_jsxs(StyledContainer, {
        children: [/*#__PURE__*/_jsx(DropdownStyle, {}), /*#__PURE__*/_jsxs(StyledHeaderRow, {
          children: [/*#__PURE__*/_jsxs(StyledTitleLabel, {
            children: [label === null || label === void 0 ? void 0 : label.expectationAssignment, isRequired && /*#__PURE__*/_jsx(StyledRequired, {
              children: "*"
            })]
          }), totalFormScoreText && /*#__PURE__*/_jsx(StyledTotalScoreBadge, {
            children: totalFormScoreText
          })]
        }), /*#__PURE__*/_jsxs(StyledSubLabelsRow, {
          children: [/*#__PURE__*/_jsx(StyledSubLabelUnit, {
            children: unitLabel
          }), /*#__PURE__*/_jsx(StyledSubLabelValue, {
            children: valueLabel
          })]
        }), /*#__PURE__*/_jsxs(StyledInputsRow, {
          children: [/*#__PURE__*/_jsx(Form.Item, {
            name: "expectationType",
            initialValue: ExpectationUnit.Percentage,
            noStyle: true,
            children: /*#__PURE__*/_jsxs(StyledTypeSelect, {
              value: expectationType,
              onChange: handleTypeChange,
              dropdownClassName: "expectation-dropdown-overlay",
              dropdownMatchSelectWidth: false,
              children: [/*#__PURE__*/_jsx(Select.Option, {
                value: ExpectationUnit.Percentage,
                children: percentageLabel
              }), /*#__PURE__*/_jsx(Select.Option, {
                value: ExpectationUnit.Score,
                children: scoreLabel
              })]
            })
          }), /*#__PURE__*/_jsx(StyledValueFormItem, {
            name: "expectation",
            initialValue: 50,
            validateTrigger: ['onChange', 'onBlur'],
            extra: hintText,
            rules: [{
              validator: function () {
                var _validator = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_, value) {
                  var numericValue;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (!(value == null || value === '')) {
                            _context.next = 4;
                            break;
                          }

                          if (!isRequired) {
                            _context.next = 3;
                            break;
                          }

                          return _context.abrupt("return", Promise.reject((errorLabel === null || errorLabel === void 0 ? void 0 : errorLabel.typeExpectationMessage) || (errorLabel === null || errorLabel === void 0 ? void 0 : errorLabel.expectationIsRequired) || ''));

                        case 3:
                          return _context.abrupt("return", Promise.resolve());

                        case 4:
                          numericValue = Number(value);

                          if (!(isNaN(numericValue) || numericValue < 0)) {
                            _context.next = 7;
                            break;
                          }

                          return _context.abrupt("return", Promise.reject((errorLabel === null || errorLabel === void 0 ? void 0 : errorLabel.expectationNotAValidNumber) || ''));

                        case 7:
                          if (!isPercentage) {
                            _context.next = 12;
                            break;
                          }

                          if (Expectation.isValidPercentage(numericValue)) {
                            _context.next = 10;
                            break;
                          }

                          return _context.abrupt("return", Promise.reject(percentageErrorMsg));

                        case 10:
                          _context.next = 14;
                          break;

                        case 12:
                          if (Expectation.isValidScore(numericValue, maxScore)) {
                            _context.next = 14;
                            break;
                          }

                          return _context.abrupt("return", Promise.reject(scoreErrorMsg));

                        case 14:
                          return _context.abrupt("return", Promise.resolve());

                        case 15:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                function validator(_x, _x2) {
                  return _validator.apply(this, arguments);
                }

                return validator;
              }()
            }, {
              required: isRequired,
              message: (errorLabel === null || errorLabel === void 0 ? void 0 : errorLabel.missingExpectation) || (errorLabel === null || errorLabel === void 0 ? void 0 : errorLabel.expectationIsRequired) || ''
            }],
            children: /*#__PURE__*/_jsxs(StyledInputWrapper, {
              children: [/*#__PURE__*/_jsx(InputNumber, {
                value: currentExpectationValue,
                onChange: handleInputChange,
                step: 1,
                placeholder: isPercentage ? '50' : "".concat(Math.round(maxScore / 2))
              }), !isPercentage && /*#__PURE__*/_jsxs(StyledSuffixText, {
                children: ["/ ", maxScore]
              })]
            })
          })]
        })]
      });
    }
  });
};